<template>
  <div class="promotion_header">
    <div class="promotion_header_left">
      <img :src="imgFront" class="t_img" />
      <div>
        <div>
          <h1 class="promotion_header_left_title">{{ title }}</h1>
          <div v-show="amount > 0" class="promotion_header_left_amount">
            浏览量：{{ amount }}
          </div>
        </div>
      </div>
    </div>
    <div class="promotion_header_right block">
      <div
        @click="onClickRegist"
        class="promotion_header_right_button default_button"
      >
        <strong class="font_weight_500">我要报名</strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgFront: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClickRegist() {
      this.$emit('onClickPromotionHeader')
    }
  }
}
</script>
<style lang="scss">
.promotion-rich-text {
  white-space: break-spaces;
}
.t_img {
  margin-right: 15px;
  width: 135px;
  height: 76px;
  object-fit: cover;
}
.promotion_header {
  width: 100%;
  height: 106px;
  border: 1px solid rgba(239, 241, 242, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  .promotion_header_left {
    margin: 30px 15px 30px 15px;
    width: 855px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    .promotion_header_left_title {
      font-size: 24px;
      font-weight: 500;
      color: rgba(68, 68, 68, 1);
      line-height: 30px;
      padding-bottom: 10px;
    }
    .promotion_header_left_amount {
      font-size: 16px;
      font-weight: 400;
      color: rgba(155, 155, 155, 1);
      line-height: 16px;
    }
  }

  .promotion_header_right_button {
    margin: 10px auto;
    height: 46px;
    width: 200px;
  }
  .promotion_header_right {
    width: 33%;
    border-left: 1px solid rgba(239, 241, 242, 1);
  }
}
</style>
